import React from 'react';

import SearchAndResults from './SearchAndResults';

export default class SearchAndResultsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.entityClick = this.entityClick.bind(this);
    this.hideResults = this.hideResults.bind(this);
    this.search = this.search.bind(this);
    this.state = {
      searchResultsHidden: true,
      showSearching: false,
    };
  }

  search(term) {
    this.setState({
      ...this.state,
      showSearching: false,
      searchResultsHidden: false,
    });

    this.props.executeSearch(term);
  }

  hideResults() {
    this.setState({
      ...this.state,
      searchResultsHidden: true,
    });
  }

  entityClick(entity) {
    this.setState({
      ...this.state,
      searchResultsHidden: true,
    });

    this.props.selectEntity(entity);
  }

  componentDidUpdate() {
    if (this.searchingHandle) {
      clearTimeout(this.searchingHandle);
    }

    this.searchingHandle = setTimeout(() => {
      this.setState({
        ...this.state,
        showSearching: true,
      });
    }, 500);
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      showSearching: false,
      searchResultsHidden: true,
    });
  }

  componentWillUnmount() {
    if (this.searchingHandle) {
      clearTimeout(this.searchingHandle);
    }
  }

  render() {
    const {searchResults, searchTerm, isSearching} = this.props;
    const {searchResultsHidden} = this.state;

    const searchLoading = this.state.showSearching && isSearching;

    return (
      <div className="search-and-results-container">
        <SearchAndResults
          {...this.props}
          entities={searchResults}
          searchTerm={searchTerm}
          hideResults={searchResultsHidden}
          onClickOutside={this.hideResults}
          searchTermChanged={this.search}
          entityClick={this.entityClick}
          searchLoading={searchLoading}
        />
      </div>
    );
  }
}
